import { Combobox } from "@ttc3k/trekker";
import { Multilingual } from "gql/generated";

export interface ILink {
  path: string;
  name: string;
}

export interface TabProps {
  value: string;
  title: string;
}

export enum Days {
  Sun = "SUN",
  Mon = "MON",
  Tue = "TUE",
  Wed = "WED",
  Thu = "THU",
  Fri = "FRI",
  Sat = "SAT",
}

export enum Months {
  Jan = "JAN",
  Feb = "FEB",
  Mar = "MAR",
  Apr = "APR",
  May = "MAY",
  Jun = "JUN",
  Jul = "JUL",
  Aug = "AUG",
  Sep = "SEP",
  Oct = "OCT",
  Nov = "NOV",
  Dec = "DEC",
}

export type MultilingualLangKey = keyof Omit<Multilingual, "__typename">;

export type DistanceUnit = "metric" | "imperial";

export type Collection = ReturnType<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof Combobox.useCollection<any>
>["collection"];
